import React from 'react';
import { ErrorMessageFullScreen } from '@browsing/components';

export const GenericErrorPage = () => {
    return <ErrorMessageFullScreen path="error" withCta={false} />;
};
